module.exports = __webpack_public_path__ + "img/bg.be07d990.png";